performTransaction